import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { ERROR } from '../const/error';

export type Brand = {
  id: number;
  accountId: number;
  logoUrl: string;
  name: string;
  url: string;
  categories: BrandCategory[];
  hidden: boolean;
};

export type BrandsOfStores = {
  accountId: number;
  name: string;
  brands: Brand[];
};

export type BrandsResponse = {
  brandsOfStores: BrandsOfStores[];
};

export enum BrandCategory {
  HEALTH_AND_WELLNESS = 'Health and wellness',
  APPAREL_AND_FOOTWEAR = 'Apparel and footwear',
  HOME_AND_HOBBY = 'Home and hobby',
  SPORT_AND_HIKING = 'Sport and hiking',
  ELECTRONICS = 'Electronics',
  ENTERTAINMENT_AND_GAMING = 'Entertainment and gaming',
  BABY_AND_CHILDREN = 'Baby and children',
  GROCERIES = 'Groceries',
  JEWELRY_AND_WATCHES = 'Jewelry and watches',
}

export async function fetchAllBrands(): Promise<BrandsResponse | null> {
  try {
    const url = `${settings.newApiUrl}/brands`;
    const response = await Fetch.get({ url });

    if (response.ok) return response.json();
    return null;
  } catch (e) {
    console.log(ERROR.FETCH_BRANDS_INFO, e);
    return null;
  }
}
